import React from 'react'
import {Link} from 'react-router-dom'
import he from 'he'

const ComedyVideosListCard = ({item,index,hydrating}) => {

  const isTelugu = (text) => /[\u0C00-\u0C7F]/.test(text);
       
  return (
    <div  className={`comedy-videosList-card ${hydrating ? 'ssr-hidden' : ''}`} >
      
               <Link className='img-anchor' to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/videodetails')) : ''} >
           <img
  src={item.stimg ? item.stimg : '/comedy/assets/images/error_img.webp'}
  alt="card-img"
  className="comedy-videosList-card-img"
  loading={ index === 0 ? "eager" : index < 4 ? "auto" : "lazy"}
  fetchpriority={index === 0 ? "high"  : index < 4 ? "auto"  : "low" } />
               </Link>
              
                <Link to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/videodetails')) : ''}
                   className={`comedy-videosList-card-title ${isTelugu(item.vgal_title) && item.vgal_title ? "comedy-videosList-card-title-tl" : 'comedy-videosList-card-title-en'}`}>{item.vgal_title ? item.vgal_title : "No Title"}</Link>
             

    </div>
  )
}

export default ComedyVideosListCard;
